<template lang="pug">
  div.registry.object-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :showSaveButton="showSaveButton"
      :hideDeleteButton="hideDeleteButton"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование объекта"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="cadastr_code"
                  inputType="input"
                  label="Кадастровый номер земельного участка"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="is_intermunicipal"
                  :model="fields"
                  tabView="tab1"
                  caption="Межмуниципальный"
                  inputType="checkbox"
                )

                e-form-group(
                  name="is_mps"
                  :model="fields"
                  tabView="tab1"
                  caption="МПС"
                  inputType="checkbox"
                )

                e-form-group(
                  name="tkoActions"
                  :model="fields"
                  tabView="tab1"
                  label="Назначение объекта"
                  :options="ACTIONS"
                  optionValueKey="tko_action_id"
                  optionTextKey="label"
                  inputType="checkbox[]"
                )

                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="garbage_groups"
                  :model="fields"
                  tabView="tab1"
                  label="Группы обслуживаемых отходов"
                  :options="garbageGroupsOptions"
                  inputType="suggestion[]"
                )

              div.col
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab2"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

                e-form-group(
                  name="status_id"
                  inputType="select"
                  label="Статус объекта"
                  :model="fields"
                  :options="statuses"
                  :required="true"
                  :disabled="statusDisabled"
                  tabView="tab1"
                )
                e-form-group(
                  name="object_date_start"
                  inputType="select"
                  label="Год ввода в эксплуатацию"
                  :model="fields"
                  tabView="tab1"
                  :options="operationYear"
                )
                e-form-group(
                  name="object_date_finish"
                  inputType="select"
                  label="Год окончания эксплуатации"
                  :model="fields"
                  tabView="tab1"
                  :options="operationYear"
                )
                e-form-group(
                  name="area"
                  inputType="input"
                  label="Площадь земельного участка, в Га"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="activity"
                  inputType="textarea"
                  label="Требуемые мероприятия по приведению мест накопления в соответствие с нормами законодательства"
                  :model="fields"
                  tabView="tab1"
                )

              div.col
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="true"
                  :addressData="addressData"
                  :freezeLatLng="isFieldDisabled('location')"
                  tabView="tab1"
                )

                e-form-group(
                  name="detail"
                  inputType="textarea"
                  label="Контактные данные"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="link"
                  inputType="url"
                  label="Сайт"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="orientir_distance"
                  inputType="input"
                  label="Расстояние до ближайшего населенного пункта, км"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="orientir"
                  inputType="input"
                  label="Ориентир"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

            div.body
              div.col
                e-form-group(
                  name="operator"
                  inputType="input"
                  label="Эксплуатирующая организация"
                  :model="fields"
                  tabView="tab1"
                )
              div.col

          // ТАРИФЫ
          tko-tariff(
            v-show="tabView === 'tariffs'"
            :tkoOperatorTariffs="fields.tkoObjectTariffs"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
          )

            // вкладка ТЕХНОЛОГИИ
          div(v-show="tabView === 'tab2'")
            technology-table(
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="technologyTable"
              tabView="tab2")

          //РАЗМЕЩЕНИЕ
          div(v-show="tabView === 'tab3'")
            div.body
              div.col
                e-form-subtitle(text="Характеристика объекта размещения отходов")

                e-form-group(
                  name="coefficient_compaction"
                  label="Коэффициент уплотнения"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(TransportationId) > -1"
                )
                e-form-group(
                  name="part_secondary"
                  label="Доля отбора вторичных материальных ресурсов"
                  :model="fields"
                  validationRule="number"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(TransportationId) > -1 || fields.tkoActions.indexOf(ProcessingId) > -1"
                  :validationAdditionalRules="{minValue: 0, maxValue: 100}"
                )
                e-form-group(
                  name="part_fuel_production"
                  label="Доля отбора полезных фракций для компостирования и производства RDF-топлива"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(ProcessingId) > -1"
                  :validationAdditionalRules="{minValue: 0, maxValue: 100}"
                )

                e-form-group(
                  name="tko_object_type_id"
                  inputType="select"
                  label="Вид объекта"
                  :model="fields"
                  :options="tkoObjectTypeOptions"
                  tabView="tab3"
                )
                e-form-group(
                  name="tko_object_state_id"
                  inputType="select"
                  label="Состояние объекта"
                  :model="fields"
                  :options="tkoObjectStateOptions"
                  tabView="tab3"
                )

                e-form-group(
                  name="area_garbage"
                  label="Площадь участка под рамещение отходов, кв.м."
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )

                div.col-sub-cols-2
                  e-form-group(
                    name="power"
                    label="Мощность, тыс. тонн/год"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                  e-form-group(
                    name="power_kub"
                    label="Мощность, тыс. куб.м"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                div.col-sub-cols-2
                  e-form-group(
                    name="project_capacity"
                    label="Вместимость объекта, тыс. тонн"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                    @change="changeCapacity"
                  )
                  e-form-group(
                    name="capacity_proj_kub"
                    label="Вместимость объекта, куб.м"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                div.col-sub-cols-2
                  e-form-group(
                    name="leftover_capacity"
                    label="Остаточная ёмкость, тыс. тонн"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                  e-form-group(
                    name="capacity_rem_kub"
                    label="Остаточная ёмкость, куб.м"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                div.col-sub-cols-2
                  e-form-group(
                    name="accumulated"
                    label="Накоплено, тыс. тонн"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                    @change="changeAccumulate"
                  )
                  e-form-group(
                    name="accumulated_cubic"
                    label="Накоплено, куб.м"
                    :model="fields"
                    validationRule="double"
                    tabView="tab3"
                  )
                div.col-sub-cols-2
                  e-form-group(
                    name="accumulated_calculate"
                    label="Процент заполнения объекта, %"
                    :model="calculate"
                    validationRule="double"
                    tabView="tab3"
                  )
                e-form-group(
                  name="operation_period"
                  label="Остаточный срок эксплуатации объекта, лет"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  :disabled="true"
                )

              div.col
                e-form-subtitle(text="Документация")
                e-form-group(
                  name="has_doc_building"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на строительство объекта"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="has_doc_recultivation"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на рекультивацию земельного участка"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="has_expertise"
                  :model="fields"
                  tabView="tab3"
                  label="Положительное заключение гос. экологической экспертизы"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="number"
                  label="Номер документа"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.number"
                )
                e-form-group(
                  name="dt"
                  input-type="calendar"
                  label="От"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.dt"
                )
                e-form-group(
                  name="organization"
                  label="Выдавшая организация"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.organization"
                )


              div.col
                e-form-subtitle(text="ГРОРО")

                e-form-group(
                  name="has_groro"
                  :model="fields"
                  tabView="tab3"
                  label="Включение объекта в ГРОРО"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="dt"
                  input-type="calendar"
                  label="От"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.dt"
                )
                e-form-group(
                  name="number"
                  label="Номер документа"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.number"
                )
                e-form-group(
                  name="groro_number"
                  label="Номер ГРОРО"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.groro_number"
                )

            div.body
              div.col
                utilization-products-table(
                  v-if="showUtilizationProducts"
                  :model="fields"
                  :dataUrl="utilizationProductsDataUrl"
                  tabView="tab3"
                  :formValidator="formValidator"
                  validate-alias="utilizationProducts"
                )


          //ДОКУМЕНТЫ
          div(v-show="tabView === 'tab4'")
            div.body
              div.col
                e-form-subtitle(text="На земельный участок")
                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  name="number"
                  validationRule="number"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                )


                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )


              div.col
                e-form-subtitle(text="На установку")

                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                )


                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )

              div.col




          // вкладка СВЕДЕНИЯ ПО ОТХОДАМ
          div(v-show="tabView === 'tab5'")
            r-registry-object-garbage-table(
              :fields="fields"
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="garbageTable"
              tabView="tab5"
            )

          // вкладка Х-КА
          div(v-show="tabView === 'tab6'")
            div.body
              div.col
                e-form-group(
                  name="has_monitoring"
                  :model="fields"
                  tabView="tab6"
                  label="Наличие систем мониторинга окружающей среды на объекте"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="road_types"
                  :model="fields"
                  tabView="tab6"
                  label="Характеристики подъездных путей"
                  inputType="suggestion[]"
                  :options="specOfAccessRoadsOptions"
                )

              div.col
                e-form-group(
                  name="engineering_systems"
                  :model="fields"
                  tabView="tab6"
                  label="Инженерное обеспечение"
                  inputType="checkbox[]"
                  :options="engineeringSystemOptions"
                )

              div.col

          // Маршруты
          div(v-if="tabView === 'routes'").routes
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")

          //Журнал изменений
          div(v-show="tabView === 'tab7'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          //Документы
          div(v-show="tabView === 'tab8'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
  import { core, tko } from '../../../api/api-endpoints.js'
  import objectForm from '../mixins/object-form.js'
  import TechnologyTable from '../components/technology-table'
  import RoutesTable from '../components/routes-table'
  import UtilizationProductsTable from '../components/utilization-products-table'
  import { UtilizationId } from '../../../config/config'
  import TkoTariff from '../components/tko-tariff'

  export default {
    components: {
      TkoTariff,
      RoutesTable,
      UtilizationProductsTable,
      TechnologyTable
    },
    mixins: [objectForm],
    data() {
      return {
        errors: null,
        calculate: {
          accumulated_calculate: 0
        }
      }
    },
    computed: {
      // for use in src/app/registry/OperatorAllUpdate.vue
      // with duplicate id route
      itemId() {
        return this.$route.params.objectId || this.$route.params.id || null
      },
      moduleId() {
        return this.moduleIds['tko-object']
      },
      showUtilizationProducts() {
        return this.fields.tkoActions.indexOf(
          UtilizationId
        ) > -1
      },
      tabs() {
        const tabs = [{ tab1: 'Общие сведения' }, { tab2: 'Технологии' }, { tab3: 'Размещение' }, { tab4: 'Документы' }, { tab5: 'Сведения по отходам' }, { tab6: 'Характеристика' }, { routes: 'Маршруты' }, { tariffs: 'Тарифы' }]
        if (this.fields.id) {
          tabs.push({ tab7: 'Журнал изменений' })
        }
        tabs.push({ tab8: 'Документы' })
        return tabs
      }
    },
    beforeDestroy() {
      // reset
      this.$store.commit('setEndpointData', {
        endpoint: this.utilizationProductsDataUrl(),
        data: {
          data: []
        }
      })
    },
    methods: {
      calcFieldAccumulate() {
        if (Number.isInteger(this.fields.accumulated) && Number.isInteger(this.fields.project_capacity)) {
          this.calculate.accumulated_calculate = (this.fields.accumulated / this.fields.project_capacity) * 100
        } else {
          this.calculate.accumulated_calculate = 0
        }
      },
      changeCapacity(val) {
        this.fields.project_capacity = parseInt(val.target.value)
        this.calcFieldAccumulate()
      },
      changeAccumulate(val) {
        this.fields.accumulated = parseInt(val.target.value)
        this.calcFieldAccumulate()
      },
      utilizationProductsDataUrl() {
        return 'utilizationProductsOfflineUrl'
      },
      transformFieldsBeforeSend() {
        objectForm.methods.transformFieldsBeforeSend.call(this)

        // copy form offline
        const is = this.$store.getters.readUrlEndpoint(
          this.utilizationProductsDataUrl()
        )

        // and past to fields for save on server
        if (is && is.data.length > 0) {
          this.fields.utilizationProducts = is.data.slice()
        } else {
          this.fields.utilizationProducts = []
        }
      },
      update() {
        objectForm.methods.update.call(this)

        if (this.item) {
          if (this.fields.accumulated && this.fields.project_capacity) {
            this.calculate.accumulated_calculate = (this.fields.accumulated / this.fields.project_capacity) * 100
          }

          // copy data from item arr to store in offline endpoint
          const is = this.item.utilizationProducts || []
          // put data to store
          this.$store.commit('setEndpointData', {
            endpoint: this.utilizationProductsDataUrl(),
            data: {
              // drop deep link to objects
              data: JSON.parse(JSON.stringify(is))
            }
          })
        }
      },
      getDocumentsEndpoint(id) {
        return core.documents(id)
      },
      getTkoOperatorEndpoint() {
        return core.statuses({ fields: 'tko_operator' })
      },
      getCollectionEndpoint() {
        return core.collection(
          'garbage_group,status,engineering_system,road_type,tko_object_type,tko_object_state',
          {query: {type: 'tko_object'}}
        )
      },
      getDeleteUrl(id) {
        return tko.objectDelete(id)
      },
      getUpdateOrCreateUrl() {
        let itemId = this.$route.params.objectId || this.$route.params.id || null
        return tko.objectUpdateOrCreate(itemId)
      },
      getItemEndpoint(route) {
        let itemId = route.params.objectId || route.params.id || null
        if (!itemId) {
          return null
        }
        return tko.object(itemId)
      }
    }
  }
</script>
